import {NgModule} from "@angular/core";
import {RouterModule} from "@angular/router";
import {CommonModule} from "@angular/common";
import {TranslateModule} from "@ngx-translate/core";
import {FamilyCardComponent} from "./family-card.component";
import {ProductSolrImageDirectiveModule} from '@signature-it/ngx-catalogue/directives';
import {ReplaceTokensPipeArrayModule, SafePipeModule } from '@signature-it/ngx-generic/pipes';
@NgModule({
    declarations: [
        FamilyCardComponent
    ],
    imports: [
        CommonModule,
        TranslateModule,
        RouterModule,
        ProductSolrImageDirectiveModule,
        ReplaceTokensPipeArrayModule,
        SafePipeModule
    ],
    exports: [FamilyCardComponent]
})
export class FamilyCardModule_Catalogue {}
